import Draw104Correction from '../pages/Draw104Correction';
import ReferrersManagement from '../pages/ReferrersManagement';
import Influencers from '../pages/Influencers';
import InfluencerTerms from '../pages/InfluencerTerms';
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "../layouts/AdminLayout";
import AdminRouteGuard from "../components/AdminRouteGuard";

import AdminLogin from "../pages/AdminLogin";
import AdminForgotPassword from "../pages/AdminForgotPassword";
import AdminVerifyResetOtp from "../pages/AdminVerifyResetOtp";
import AdminResetPassword from "../pages/AdminResetPassword";
import PresenterLogin from "../pages/PresenterLogin";
import Users from "../pages/Users";
import CustomerProfile from "../pages/CustomerProfile";
import Box from "@mui/material/Box";
import { Colors } from "../utils/colors";
import DeleteUser from "../pages/DeleteUser";
import SuspendUser from "../pages/SuspendUser";
import ModifyUser from "../pages/ModifyUser";
import CreateUser from "../pages/CreateUser";
import Admins from "../pages/Admins";
import AdminProfile from "../pages/AdminProfile";
import CreateAdmin from "../pages/CreateAdmin";
import ModifyAdmin from "../pages/ModifyAdmin";
import SuspendAdmin from "../pages/SuspendAdmin";
import DeleteAdmin from "../pages/DeleteAdmin";
import Transactions from "../pages/Transactions";
import Draws from "../pages/Draws";
import AdminLiveDraw from "../pages/AdminLiveDraw";
import Winners from "../pages/Winners";
import Tickets from "../pages/Tickets";
import Messages from "../pages/Messages";
import Settings from "../pages/Settings";
import Profile from "../pages/Profile";
import AuditLogs from "../pages/AuditLogs";
import FAQs from "../pages/FAQs";
import HowToPlay from "../pages/HowToPlay";
import SocialMetrics from "../pages/SocialMetrics";
import BlockedRegistrationNames from "../pages/BlockedRegistrationNames";
import PresenterAccounts from "../pages/PresenterAccounts";

import Analytics from "../pages/Analytics";
import BulkEmail from "../pages/BulkEmail";
import ProfileCenter from "../pages/ProfileCenter";
import LegacyInfluencerHistory from "../pages/LegacyInfluencerHistory";
import SignupActivity from "../pages/SignupActivity";


export default function AppRouter(){

return(
<Box sx={{display:"flex", justifyContent:"center", alignItems:"center", minHeight:"100vh", width:"100%", maxWidth:"100%", overflowX:"hidden", backgroundColor:Colors.secondary}}>

<Routes>

<Route path="/" element={<AdminLogin />} />
<Route path="/presenter/login" element={<PresenterLogin />} />
<Route path="/forgot-password" element={<AdminForgotPassword />} />
<Route path="/verify-reset-otp" element={<AdminVerifyResetOtp />} />
<Route path="/reset-password" element={<AdminResetPassword />} />
<Route
path="/admin/draws/live/:id"
element={
  <AdminRouteGuard allowedRoles={["super_admin", "presenter"]}>
    <AdminLiveDraw />
  </AdminRouteGuard>
}
/>

<Route
path="/admin"
element={
  <AdminRouteGuard allowedRoles={["super_admin", "finance_admin", "support_admin"]}>
    <AdminLayout />
  </AdminRouteGuard>
}
>


<Route path="customer-referrals" element={<AdminRouteGuard allowedRoles={["super_admin","finance_admin"]}><Navigate to="/admin/referrers?section=referrals" replace /></AdminRouteGuard>} />
<Route path="admins" element={<Admins />} />
<Route path="admins/:adminId/profile" element={<AdminRouteGuard allowedRoles={["super_admin"]}><AdminProfile /></AdminRouteGuard>} />
<Route
path="/admin/admin/create"
element={
 <CreateAdmin/>
}
/>
<Route path="/admin/admin/modify" element={<ModifyAdmin />} />
<Route path="/admin/admin/suspend" element={<SuspendAdmin />} />
<Route path="/admin/admin/delete" element={<DeleteAdmin />} />

<Route path="users" element={<Users />} />
<Route path="users/:userId/profile" element={<AdminRouteGuard allowedRoles={["super_admin"]}><CustomerProfile /></AdminRouteGuard>} />
<Route path="profile-center" element={<ProfileCenter />} />
<Route path="signup-activity" element={<AdminRouteGuard allowedRoles={["super_admin", "support_admin"]}><SignupActivity /></AdminRouteGuard>} />
<Route path="transactions" element={<Transactions />} />
<Route path="draws" element={<Draws />} />
<Route path="draws/104/correction" element={<AdminRouteGuard allowedRoles={["super_admin"]}><Draw104Correction /></AdminRouteGuard>} />
<Route path="winners" element={<AdminRouteGuard allowedRoles={["super_admin"]}><Winners /></AdminRouteGuard>} />
<Route path="tickets" element={<Tickets />} />
<Route path="messages" element={<Messages />} />
<Route path="faqs" element={<FAQs />} />
<Route path="how-to-play" element={<HowToPlay />} />
<Route path="social-metrics" element={<SocialMetrics />} />
<Route path="presenter-accounts" element={<PresenterAccounts />} />
<Route path="influencers" element={<AdminRouteGuard allowedRoles={["super_admin"]}><Influencers /></AdminRouteGuard>} />
<Route path="referrers" element={<AdminRouteGuard allowedRoles={["super_admin","finance_admin"]}><ReferrersManagement /></AdminRouteGuard>} />
<Route path="agents" element={<Navigate to="/admin/influencers" replace />} />
<Route path="influencers/legacy-history" element={<AdminRouteGuard allowedRoles={["super_admin"]}><LegacyInfluencerHistory /></AdminRouteGuard>} />
<Route path="influencer-terms" element={<AdminRouteGuard allowedRoles={["super_admin"]}><InfluencerTerms /></AdminRouteGuard>} />
<Route path="analytics" element={<Analytics />} />
<Route path="bulk-email" element={<AdminRouteGuard allowedRoles={["super_admin"]}><BulkEmail /></AdminRouteGuard>} />
<Route path="blocked-registration-names" element={<BlockedRegistrationNames />} />
<Route
  path="settings"
  element={
    <AdminRouteGuard allowedRoles={["super_admin"]}>
      <Settings />
    </AdminRouteGuard>
  }
/>
<Route path="profile" element={<Profile />} />
<Route path="audit-logs" element={<AuditLogs />} />
<Route path="/admin/user/delete" element={<DeleteUser/>} />
<Route path="/admin/user/suspend" element={<SuspendUser/>} />
<Route path="/admin/user/modify" element={<ModifyUser/>} />
<Route path="/admin/user/createuser" element={<CreateUser/>} />




</Route>

</Routes>
</Box>

)

}
